import React from 'react'
import NearbySkeletonCard from '../../organisms/Loaders/NearbySkeletonCard'

export default function HorizontalScrollLoader({ hideDescription = false }) {
  return (
    <>
      <NearbySkeletonCard hideDescription={hideDescription} />
      <NearbySkeletonCard hideDescription={hideDescription} />
      <NearbySkeletonCard hideDescription={hideDescription} />
      <NearbySkeletonCard hideDescription={hideDescription} />
    </>
  )
}
